import { unref } from 'vue';

/**
 * @param {String|MaybeRef<String>} type
 * @returns {boolean}
 */
export default function isRangeType(type) {
    return ['number', 'range', 'integer'].includes(unref(type).toLowerCase());
}
